// standards-ignore: co-located-test — pure constant + type-only module (i18n
// bundle id and key union), no logic to test.

/** i18n bundle + typed key union shared by SubQuestionsStep and SubQuestionRow. */
export const SUB_QUESTIONS_BUNDLE = 'features.audit-whiz.translations.reviewQuestions';

export type SubKey =
  | 'subStepHeading'
  | 'subSectionHeading'
  | 'subSectionInfo'
  | 'subInfoAltText'
  | 'subAddButton'
  | 'subConditionalToggleLabel'
  | 'subConditionalOnDescription'
  | 'subConditionalOffDescription'
  | 'subConditionalBlockedError'
  | 'subConditionalDefaultedInfo'
  | 'subConditionalEnabledInfo'
  | 'subConditionalDisabledInfo'
  | 'subConditionalDismissAltText'
  | 'subRowLabel'
  | 'subUntitledLabel'
  | 'subDeleteAltText'
  | 'subEmptyText'
  | 'subTitleLabel'
  | 'subTitlePlaceholder'
  | 'subInstructionLabel'
  | 'subInstructionPlaceholder'
  | 'subCommentOnFailLabel'
  | 'subCommentOnFailInfo'
  | 'subEvidenceOnFailLabel'
  | 'subEvidenceOnFailInfo'
  | 'subCommentOnPassLabel'
  | 'subCommentOnPassInfo'
  | 'subEvidenceOnPassLabel'
  | 'subEvidenceOnPassInfo'
  | 'subTaskHeading'
  | 'subAddTaskButton'
  | 'subRemoveTaskButton'
  | 'subResponseTypeLabel'
  | 'subResponseTypeInfo'
  | 'subResponseTypePassFail'
  | 'subResponseTypeText'
  | 'subResponseTypeNumeric'
  | 'subResponseTypeSingleSelect'
  | 'subResponseTypeMultiSelect'
  | 'subResponseTypeYesNo'
  | 'subResponseTypeUserAlias'
  | 'subShowOnLabel'
  | 'subShowOnInfo'
  | 'subShowOnPass'
  | 'subShowOnFail'
  | 'subShowOnBoth'
  | 'subOptionsLabel'
  | 'subOptionPlaceholder'
  | 'subOptionAriaLabel'
  | 'subOptionAddButton'
  | 'subOptionRemoveAltText'
  | 'subOptionsMinText'
  | 'subRequireCommentLabel'
  | 'subRequireCommentInfo'
  | 'subRequireAttachmentLabel'
  | 'subRequireAttachmentInfo'
  | 'criteriaTaskNameLabel'
  | 'criteriaTaskNamePlaceholder'
  | 'criteriaTaskDescriptionLabel'
  | 'criteriaTaskDescriptionPlaceholder'
  | 'criteriaTaskDurationLabel'
  | 'criteriaTaskDurationPlaceholder';
